import { render, staticRenderFns } from "./abstract-course-header.vue?vue&type=template&id=164fbf7a&scoped=true"
import script from "./abstract-course-header.vue?vue&type=script&lang=js"
export * from "./abstract-course-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164fbf7a",
  null
  
)

export default component.exports